var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedListButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 11.8325C5.33301 11.5564 5.55687 11.3325 5.83301 11.3325H14.833C15.1091 11.3325 15.333 11.5564 15.333 11.8325C15.333 12.1087 15.1091 12.3325 14.833 12.3325H5.83301C5.55687 12.3325 5.33301 12.1087 5.33301 11.8325Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 7.83252C5.33301 7.55638 5.55687 7.33252 5.83301 7.33252H14.833C15.1091 7.33252 15.333 7.55638 15.333 7.83252C15.333 8.10866 15.1091 8.33252 14.833 8.33252H5.83301C5.55687 8.33252 5.33301 8.10866 5.33301 7.83252Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 3.83252C5.33301 3.55638 5.55687 3.33252 5.83301 3.33252H14.833C15.1091 3.33252 15.333 3.55638 15.333 3.83252C15.333 4.10866 15.1091 4.33252 14.833 4.33252H5.83301C5.55687 4.33252 5.33301 4.10866 5.33301 3.83252Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0459 12.1978V11.7231H2.33301C2.5498 11.7231 2.69629 11.5864 2.69629 11.4067C2.69629 11.2212 2.53809 11.0962 2.33496 11.0962C2.1123 11.0962 1.96777 11.2485 1.96191 11.4067H1.37207C1.3877 10.9399 1.74512 10.6196 2.3584 10.6196C2.94629 10.6177 3.31152 10.9106 3.31543 11.3228C3.31934 11.7017 3.0127 11.8872 2.82324 11.9165V11.9497C3.07715 11.9731 3.3877 12.1646 3.3916 12.5806C3.39551 13.1138 2.88965 13.3813 2.34082 13.3813C1.68457 13.3813 1.34082 13.0103 1.33301 12.5864H1.91504C1.92285 12.7642 2.10059 12.8931 2.33691 12.895C2.59082 12.895 2.76074 12.7505 2.75879 12.5454C2.75684 12.3501 2.60449 12.1978 2.34473 12.1978H2.0459Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04199 7.49854H1.43848V7.46338C1.43848 7.05518 1.7334 6.61963 2.39551 6.61963C2.97949 6.61963 3.35645 6.9458 3.35645 7.37549C3.35645 7.76416 3.09863 7.99268 2.87988 8.22314L2.34277 8.79541V8.82471H3.39746V9.33252H1.47559V8.93799L2.43262 7.94775C2.57129 7.80518 2.72559 7.64307 2.72559 7.43994C2.72559 7.26025 2.5791 7.11963 2.38379 7.11963C2.16895 7.11963 2.04199 7.27979 2.04199 7.45752C2.04199 7.47119 2.04199 7.48877 2.04199 7.49854Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89668 5.33252H2.26191V3.25635H2.23066L1.63301 3.67627V3.10986L2.26191 2.6665H2.89668V5.33252Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedListButton);
export default __webpack_public_path__ + "static/media/orderedListButton.a4c133be77a751bbae450cb878a651cb.svg";
export { ForwardRef as ReactComponent };